// extracted by mini-css-extract-plugin
module.exports = {"paper":"paper-3GGcA","serviceSelect":"serviceSelect-3cnDA","dialogHeader":"dialogHeader-ad-L6"};